import { styled } from '@mui/material/styles';
import { Fragment, SyntheticEvent, useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import {
  ContentHeader,
  HTMLWrapper,
  LightenedRule,
  SectionContainer,
  SectionHeader,
} from './sectionStyledComponents';

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: true ? 'rgba(255, 255, 255, 0)' : 'rgba(0, 0, 0, 0)',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  marginLeft: theme.spacing(1),
}));

const AccordionSection = props => {
  const [expanded, setExpanded] = useState<string | false>(false);

  function handleChange(panel: string) {
    return (event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  }

  return (
    <SectionContainer>
      {!props.isStep && <SectionHeader>{props.section.title}</SectionHeader>}
      {props.section.content.map((content, index) => {
        if (!content.header || !content.body) return <></>;

        return (
          <Fragment
            key={`${props.section.title}-${content.header}-
          ${index}`}
          >
            <Accordion
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
            >
              <AccordionSummary
                aria-controls={`panel${index}bh-content`}
                id={`panel${index}bh-header`}
                sx={{
                  [`& svg`]: {
                    fontSize: '24px',
                  },
                }}
              >
                <ContentHeader>{content.header}</ContentHeader>
              </AccordionSummary>
              <AccordionDetails>
                <HTMLWrapper innerHtml={content.body} />
              </AccordionDetails>
            </Accordion>
            <LightenedRule />
          </Fragment>
        );
      })}
    </SectionContainer>
  );
};

export default AccordionSection;
